import ReactECharts, { EChartsReactProps } from 'echarts-for-react';

export type PieChartProps = EChartsReactProps;

const PieChart = function ({ option, ...props }: PieChartProps): JSX.Element {
  return <ReactECharts className="pie-chart" option={option} {...props} />;
};

export default PieChart;
